export default function PageLayout({ children, className }) {
  return <div className={`h-screen w-screen ${className} `}>{children}</div>
}
